<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form data-vv-scope="add-new-user">
        <vx-card :title="$t('EditUser') |ToUppercase">
          <UserComponent :user="user" :passReq="''" vvFormScope="add-new-user" addNew="false"></UserComponent>
          <div class="vx-row">
            <div class="vx-col w-full mt-base">
              <vs-button @click="submitForm" class="mr-3 mb-2">{{$t('Edit') |ToUppercase}}</vs-button>
              <!-- <vs-button class="mr-3 mb-2">{{$t('Edit')}}</vs-button> -->
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import UserComponent from "../components/User";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    UserComponent
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  data: function() {
    return {
        user: {
            id: 0,
            firstname: "",
            lastname: "",
            username: "",
            password: "",
            repeatPassword: "",
            email: "",
            dealershipID: 1
        }
    };
  },
  computed: {
    activeUserInfo () {
        console.log(this.$store.state);
      return this.$store.state
    },
    dataOkEditUser(){
        console.log("In data ok");
        var message = "";
        if(this.user.password.length > 0)
        {
            if(this.user.password.length < 6) {
                message = message + "- Geslo mora vsebovati vsaj 6 znakov.<br>";
            }
            if(this.user.password != this.user.repeatPassword) {
                message = message + "- Gesli se ne ujemata.<br>";
            }
        }

        if(message.length > 0) {
            this.$vs.notify({
                title:'Napaka pri vnešenih podatkih!',
                text: message,
                color:'danger',
                iconPack: 'feather',
                icon:'icon-alert-circle',
                time: 8000
            })
            return false;
        }
        return true;
    },
  },
  methods: {
    createJsonObject() {
      let payload = {
        Id: Number(this.id),
        Firstname: this.user.firstname,
        Lastname: this.user.lastname,
        Username: this.user.username,
        Password: this.user.password,
        RepeatPassword: this.user.repeatPassword,
        Email: this.user.email,
        DealershipID: Number(this.user.dealershipID)
      };
      return payload;
    },
    async submitForm() {
        if(!this.dataOkEditUser) {
            return
        }
      let isFormValid = await this.$validator.validateAll("add-new-user");
      if (!isFormValid) return;

      this.$vs.loading();

      try {
        let payload = this.createJsonObject();
        
        let response = await this.$store.dispatch(
          "admin/editUser",
          payload
        );

        if (response.status == 200) {
          this.$vs.notify({
            text: this.$t("SuccessfullyUpdated"),
            color: "success",
            iconPack: "feather",
            icon: "icon-check-circle"
          });
          if(this.$store.state.AppActiveUser.userRole == "user") {
              await this.fetchAllData();
          }
          else {
            this.$router.push(`/user/${response.data}`);
          }
        }
      } catch (error) {
        this.$vs.notify({
          title: this.$t("Error"),
          text: error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async fetchAllData() {
      try {
        let res = await this.$store.dispatch("admin/fetchUser", this.id);
        this.user = res.data;
        this.user.password = "";
        this.user.repeatPassword = "";
      } catch (error) {
        throw error;
      }
    },
  },
  async created(){
    this.id = this.$route.params.user_id;

    //This check is required because users have access to edit user page. But if user is "user", he can only access his own data.
    if(this.$store.state.AppActiveUser.userRole == "user") {
        if(this.$store.state.AppActiveUser.uid != this.id){
            this.$router.push('/');
        }

    }

    this.$vs.loading();
    try {
      await this.fetchAllData();
    } catch (error) {
      console.log(error);
      this.notify(this.$t("Error"), this.$t("DataLoadingError"));
    } finally {
      this.$vs.loading.close();
    }
  }
};
</script>